exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-area .file-content{width:auto}.file-area .file-item{float:left!important}.file-area .file-right{float:left}.file-area .file-right .row{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:5px 0}.file-area .file-right .row .label{float:left;width:68px;text-align:right;margin-right:10px;position:relative}.file-area .file-right .row .value{float:left}.file-area.input .file-content .el-input{margin-bottom:0}.file-area .label.required:before{content:\"*\";color:red;margin-right:4px;vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b80de7a6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compo/devcDef/MerchtDevcManualSave.vue
// module id = 2409
// module chunks = 0